import {types} from './types';

const initialState = {
    list: {
        data: [],
        current: 0,
        total: 0
    },
}

export function eventsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_EVENTS:
            return { ...state, list: action.payload};
        default:
            return state
    }
}